import React, { useEffect, useState } from "react";
import Frame from "react-frame-component";
import { useSelector } from "react-redux";
import { openLink, getSelectors } from "../utils/helpers";
import SizeSelector from "../utils/size-selector";

const selectorMap = [
  {
    icon: "tv",
    key: "widedesktop1486x180",
    title: "Desktop 1486 x 180",
    width: 1486,
  },
  {
    icon: "tv",
    key: "widedesktop984x120",
    title: "Desktop 984 x 120",
    width: 984,
  },
  {
    icon: "desktop",
    key: "desktop918x110",
    title: "Desktop 918 x 110",
    width: 918,
  },
  {
    icon: "laptop",
    key: "tablet724x110",
    title: "Laptop 724px x 110",
    width: 724,
  },
  {
    icon: "tablet",
    key: "tablet532x110",
    title: "Tablet 532 x 110",
    width: 532,
  },
  {
    icon: "mobile-mpu",
    key: "mobile375x258",
    title: "Mobile 375 x 258",
    width: 375,
  },
  {
    icon: "mobile-slim",
    key: "mobile375x110",
    title: "Mobile 375 x 110",
    width: 375,
  },
];

const StageBanner = ({ banner }) => {
  const [bannerSrc, setBannerSrc] = useState();
  const selectorClass = useSelector((state) => state.divClass || "desktop");
  const deviceClass = selectorClass.split(" ")[0];

  const [selectorIcons, setSelectorIcons] = useState([]);

  useEffect(() => {
    getSelectors(banner, selectorMap).then((icons) => {
      setSelectorIcons(icons);
    });
  }, [banner]);

  useEffect(() => {
    banner.mobile375x110
      ? setBannerSrc(banner.mobile375x110.path)
      : setBannerSrc(banner.mobile375x258.path);
    if (deviceClass === "mobile-mpu") {
      banner.mobile375x258
        ? setBannerSrc(banner.mobile375x258.path)
        : setBannerSrc("");
    }
    if (deviceClass === "mobile-slim") {
      banner.mobile375x110
        ? setBannerSrc(banner.mobile375x110.path)
        : setBannerSrc("");
    }
  }, [deviceClass, banner.mobile375x110, banner.mobile375x258]);

  const url = encodeURIComponent(banner.bannerURL);

  return (
    <SizeSelector selectors={selectorIcons}>
      <Frame
        initialContent={`<!DOCTYPE html><html><head><link
          href="${process.env.PUBLIC_URL}/static/css/brand.css?v=1"
          rel="stylesheet"
        /></head><body><div id="bannerFrame"></div></body></html>`}
        mountTarget="#bannerFrame"
        className={`regular-price-${banner.includeRegularPrice}`}
      >
        <div className="wrapper" id="ghs-native">
          <div className="img-container">
            <a
              href={banner.bannerURL}
              target={banner.openLinkOptions}
              id="ref"
              onClick={(e) => openLink(e, url)}
            >
              <picture>
                <source
                  media="(max-width: 440px)"
                  srcSet={`${bannerSrc} 375w`}
                  sizes="375px"
                />
                <source
                  media="(max-width: 532px)"
                  srcSet={`${banner.tablet532x110.path} 532w`}
                  sizes="532px"
                />
                <source
                  media="(max-width: 724px)"
                  srcSet={`${banner.tablet724x110.path} 724w`}
                  sizes="724px"
                />
                <source
                  media="(max-width: 918px)"
                  srcSet={`${banner.desktop918x110.path} 918w`}
                  sizes="918px"
                />
                {banner.widedesktop984x120 && (
                  <source
                    media="(min-width: 925px) and (max-width: 984px)"
                    srcSet={`${banner.widedesktop984x120.path} 984w`}
                    sizes="925px"
                  />
                )}
                {banner.widedesktop1486x120 && (
                  <source
                    media="(min-width: 985px)"
                    srcSet={`${banner.widedesktop1486x120.path} 1486w`}
                    sizes="985px"
                  />
                )}
                {banner.widedesktop1486x180 && (
                  <source
                    media="(min-width: 925px)"
                    srcSet={`${banner.widedesktop1486x180.path} 1486w`}
                    sizes="925px"
                  />
                )}
                <img
                  alt={banner.alt}
                  id="bannerImg"
                  src={banner.desktop918x110.path}
                />
              </picture>
            </a>
          </div>
        </div>
      </Frame>
    </SizeSelector>
  );
};

export default StageBanner;
